import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Chart from './Chart';
import {Totals} from './Totals';
import InvoiceChart from '../invoice_plan/InvoiceChart';
import {BudgetDataWrapper, ChartAndHighLevelNumbers} from '../../BudgetData.styled';
import HighLevelBudgetNumbers from '../../HighLevelBudgetNumbers';
import {BUDGET_MONEY_VIEWS} from '../../../../../../constants';

const BudgetData = ({project, company, selectValueType, selectedViewType, eyeOptionMap, hasBaseline}) => {
	return (
		<BudgetDataWrapper>
			<ChartAndHighLevelNumbers>
				{BUDGET_MONEY_VIEWS.INVOICE_PLAN === selectedViewType ? (
					<InvoiceChart project={project} eyeOptionMap={eyeOptionMap} />
				) : (
					<Chart
						project={project}
						selectedViewType={selectedViewType}
						eyeOptionMap={eyeOptionMap}
						hasBaseline={hasBaseline}
					/>
				)}
				<HighLevelBudgetNumbers key={'HighLevelBudgetNumbers'} project={project} company={company} />
			</ChartAndHighLevelNumbers>
			<Totals
				company={company}
				project={project}
				eyeOptionMap={eyeOptionMap}
				selectValueType={selectValueType}
				hasBaseline={hasBaseline}
			/>
		</BudgetDataWrapper>
	);
};

export default createFragmentContainer(BudgetData, {
	company: graphql`
		fragment BudgetData_company on Company {
			tier
			...HighLevelBudgetNumbers_company
		}
	`,
	project: graphql`
		fragment BudgetData_project on ProjectType
		@argumentDefinitions(currentYear: {type: "Int"}, currentMonth: {type: "Int"}, currentMonthLastDay: {type: "Int"}) {
			...Chart_project
			...HighLevelBudgetNumbers_project
				@arguments(currentYear: $currentYear, currentMonth: $currentMonth, currentMonthLastDay: $currentMonthLastDay)
			...Totals_project
			...InvoiceChart_project
			id
			billable
		}
	`,
});
